import React from 'react'
import {
  LineChart as ReLineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
} from 'recharts'
import { CircularProgress, Typography, Box } from '@material-ui/core'
import moment from 'moment'

const LineChart = ({ label, data, unit, loading }) => {
  const calculateDomain = () => {
    if (!data || data.length === 0) return ['auto', 'auto']

    const values = data.map((item) => item.value)
    const min = Math.min(...values)
    const max = Math.max(...values)
    const padding = (max - min) * 0.1

    return [Math.max(0, min - padding), max + padding]
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: 'white',
            padding: '8px',
            border: '1px solid #ccc',
            borderRadius: '4px',
          }}
        >
          <p style={{ margin: 0 }}>{moment(label).format('YYYY-MM-DD HH:mm:ss')}</p>
          <p style={{ margin: 0, color: '#2196f3' }}>
            {payload[0].value.toFixed(2)}
            {unit || ''}
          </p>
        </div>
      )
    }
    return null
  }

  return (
    <Box 
      display='flex' 
      flexDirection='column' 
      alignItems='center'
      width="100%"
      minHeight="200px"
      p={0.5}
    >
      {loading ? (
        <Box 
          display='flex' 
          justifyContent='center' 
          alignItems='center' 
          height="180px"
          width="100%"
        >
          <CircularProgress size={24} />
        </Box>
      ) : !data || data.length === 0 ? (
        <Box 
          display='flex' 
          justifyContent='center' 
          alignItems='center' 
          height="180px"
          width="100%"
        >
          <Typography variant="body2" color="textSecondary">
            No data available
          </Typography>
        </Box>
      ) : (
        <Box 
          width='100%' 
          height="180px"
          position="relative"
        >
          <ResponsiveContainer width='100%' height='100%'>
            <ReLineChart data={data} margin={{ top: 20, right: 3, left: 2, bottom: 0 }}>
              <CartesianGrid strokeDasharray='3 3' stroke='#e0e0e0' />
              <XAxis
                dataKey='timestamp'
                tickFormatter={(t) => moment(t).format('HH:mm')}
                minTickGap={20}
                stroke='#9e9e9e'
                tick={{ fill: '#757575', fontSize: 12 }}
              />
              <YAxis
                unit={unit || ''}
                domain={calculateDomain()}
                stroke='#9e9e9e'
                tick={{ fill: '#757575', fontSize: 12 }}
                width={70}
                tickFormatter={(value) => {
                  const num = Number(value)
                  return num % 1 === 0 ? num.toString() : num.toFixed(2)
                }}
              />
              <Tooltip content={<CustomTooltip />} />
              <Line
                type='monotone'
                dataKey='value'
                stroke='#2196f3'
                strokeWidth={2}
                dot={{
                  r: 0,
                  stroke: '#2196f3',
                  strokeWidth: 1,
                  fill: '#2196f3',
                }}
                activeDot={{
                  r: 4,
                  stroke: '#2196f3',
                  strokeWidth: 1,
                  fill: '#ffffff',
                }}
              />
              {data && data.length > 0 && (
                <ReferenceLine y={Math.max(...data.map((item) => item.value))} stroke='#e0e0e0' strokeDasharray='3 3' />
              )}
            </ReLineChart>
          </ResponsiveContainer>
        </Box>
      )}
    </Box>
  )
}

export default LineChart
